import { Button } from "@aircall/tractor";
import styled from "@xstyled/styled-components";

export const StyledButton = styled(Button)`
  padding: 0;
  margin: 0;
`;
